
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Simulation1 from "../pages/simulation1/page";
import Simulation2 from "../pages/simulation2/page";
import Simulation3 from "../pages/simulation3/page";
import Simulation4 from "../pages/simulation4/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/simulation1",
    element: <Simulation1 />,
  },
  {
    path: "/simulation2",
    element: <Simulation2 />,
  },
  {
    path: "/simulation3",
    element: <Simulation3 />,
  },
  {
    path: "/simulation4",
    element: <Simulation4 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
